"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var repeater_row_1 = require("./repeater-row");
var EpsilonRepeaterSectionRow = /** @class */ (function (_super) {
    __extends(EpsilonRepeaterSectionRow, _super);
    /**
     * Constructor
     * @param {EpsilonSectionRepeater | EpsilonFieldRepeater} instance
     * @param {JQuery} rowContainer
     * @param {string} type
     */
    function EpsilonRepeaterSectionRow(instance, rowContainer, type) {
        var _this = _super.call(this, instance, rowContainer) || this;
        _this.type = type;
        _this.label = instance.control.params.sections[type].title;
        /**
         * Update labels
         */
        instance.utils.updateLabel(_this);
        _this.addTabs();
        return _this;
    }
    /**
     * Add tabs functionality ( sections have layout/styling optional settings )
     */
    EpsilonRepeaterSectionRow.prototype.addTabs = function () {
        jQuery(this.container).find('[data-group="regular"]').wrapAll('<div data-tab-id="regular" class="tab-panel regular active"></div>');
        jQuery(this.container).find('[data-group="styling"]').wrapAll('<div data-tab-id="styling" class="tab-panel styling"></div>');
        jQuery(this.container).find('[data-group="layout"]').wrapAll('<div data-tab-id="layout" class="tab-panel layout"></div>');
        this._handleTabs();
    };
    /**
     * Handle tabs functionality
     * @param container
     */
    EpsilonRepeaterSectionRow.prototype._handleTabs = function () {
        var self = this;
        var wrapper = self.container.find('nav'), tabs = self.container.find('[data-tab-id]'), tab;
        jQuery(wrapper).on('click', 'a', function (event) {
            event.preventDefault();
            jQuery(this).siblings().removeClass('active');
            jQuery(this).addClass('active');
            tab = self.container.find('[data-tab-id="' + jQuery(this).attr('data-item') + '"]');
            if (tab.length) {
                tabs.removeClass('active');
                tab.addClass('active');
            }
        });
    };
    /**
     * We'll overwrite label immediatly after construct
     * @returns {any}
     */
    EpsilonRepeaterSectionRow.prototype.getLabel = function () {
        return this.label;
    };
    return EpsilonRepeaterSectionRow;
}(repeater_row_1.EpsilonRepeaterRow));
exports.EpsilonRepeaterSectionRow = EpsilonRepeaterSectionRow;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/repeater/repeater-section-row.ts
// module id = 38
// module chunks = 0